import styled from "styled-components";
import CompleteImg from "assets/images/img_.png";

const InquiryCompleteWrapper = styled.div`
  padding-top: 8rem;
  text-align: center;

  .txt_title {
    font-size: 2.2rem;
    font-weight: 600;
    line-height: 2.6rem;
  }

  .txt_title::before {
    display: block;
    width: 8rem;
    height: 8rem;
    margin: 0 auto 4rem;
    background: url(${CompleteImg}) no-repeat center;
    background-size: 8rem;
    content: "";
  }

  .txt_desc {
    margin-top: 4rem;
    line-height: 2.2rem;
  }
`;

const Home = () => {
  return (
    <>
      <InquiryCompleteWrapper>
        <p className="txt_desc">비정상 접근입니다.</p>
      </InquiryCompleteWrapper>
    </>
  );
};

export default Home;
